import Vuex from 'vuex';
import Vue from 'vue';
import {
  Enums
} from '../Config/Config';
import MapStore from './MapStore';
import LocationSearchStore from './LocationSearchStore';
import MobileDetect from 'mobile-detect';
import {
  EventBus
} from '../EventBus';
//const querystring = require('querystring');
import queryString from 'query-string';

Vue.use(Vuex);

const Store = new Vuex.Store({
  state: () => ({
    isLoading: false,
    sidePanelOpen: true,
    sideTab: Enums.SIDE_TABS.ONE_PERSON,
    queryObj: {
      geoid: '-1',
      districtType: Enums.LEG_BODY.CONGRESS,
      mapData: Enums.MAP_VARIABLES.DEVIATION
    },
    dialogOpen: false,
    VapLayerOn: false
  }),
  mutations: {
    setDialogOpen(state, val) {
      state.dialogOpen = val;
    },
    setLoading(state, val) {
      state.isLoading = val;
    },
    setSidePanelOpen(state, val) {
      state.sidePanelOpen = val;
    },
    setSideTab(state, val) {
      EventBus.updateQueryObj(['side-tab', val.toString()]);
      state.sideTab = val;
    },
    setQueryObj(state, val) {

      state.queryObj[val[0]] = val[1];

      const url = new URL(window.location);


      if (Number(val[1]) === -1) {
        url.searchParams.delete(val[0])
      } else {
        url.searchParams.set(val[0], val[1]);
      }
      window.history.pushState({}, '', url);
    },
    setVapLayerOn(state,val){
      
      state.VapLayerOn = val;
    },
    initQueryObj(state) {

      const searchObj = queryString.parse(window.location.search.substring(1));
      //console.log(searchObj)
      //Note: There's a weird thing where if the district type is set to congress (I guess because that's default?) it doesn't show up in the searchobj here so instead you have 
      Object.keys(searchObj).forEach((key) => {
        if (state.queryObj[key] !== searchObj[key]) {
          state.queryObj[key] = searchObj[key];
          //console.log(key)
          switch (key) {

            //Very important! Set the district type and THEN set location from lat/lng or fips
            case 'districtType':
              // console.log('districttyp')
              this.commit('setDistrictType', searchObj[key]);
              if (searchObj['markerL']) {
                //console.log('setting from url marker')
                this.commit('setMarkerLoc', searchObj['markerL']);
                EventBus.$emit('select-point-from-url', searchObj['markerL']);
              } else if (searchObj['geoid']) {
                //console.log('setting from url geoid')
                EventBus.$emit("select-fips-from-url", searchObj['geoid']);
              }
              break;
            case 'markerL':
              //if (!searchObj['districtType']) {
              //console.log('setting from url marker')
              this.commit('setMarkerLoc', searchObj['markerL']);
              EventBus.$emit('select-point-from-url', searchObj['markerL']);
              // } else if (searchObj['geoid']) {
              //   console.log('setting from url geoid')
              //   EventBus.$emit("select-fips-from-url", searchObj['geoid']);
              // }
              break;
            case 'geoid':

              if (!searchObj['markerL']) {
                //console.log('setting from geoid')
                EventBus.$emit("select-fips-from-url", searchObj['geoid']);
              }
              break;
            case 'mapData':
              this.commit('setMapColumn', searchObj[key]);
              break;

            case 'side-tab':

              this.commit('setSideTab', +searchObj[key]);
              break;

            case 'tractLayer':
              // state.MapStore.commit('setgeoTypeVisible','tract')
              state.MapStore.map.once('load', () => {


                EventBus.$emit(
                  "toggle-legend-layer",
                  'tract-cvap',
                  true,
                  true
                );
              })
              break;
            case 'tractVAPLayer':
              // state.MapStore.commit('setgeoTypeVisible','tract')
              state.MapStore.map.once('load', () => {

                
                EventBus.$emit(
                  "toggle-legend-layer",
                  'tract-vap',
                  true,
                  true
                );
              })
              break;
            case 'voterLayer':
              // state.MapStore.commit('setgeoTypeVisible','tract')
              state.MapStore.map.on('load', () => {
                EventBus.$emit(
                  "toggle-legend-layer",
                  'voting-precincts',
                  true,
                  true
                );
              })
              break;
          }
        }
      });

    }
  },
  getters: {
    getDialogOpen(state) {
      return state.dialogOpen;
    },
    getLoading(state) {
      return state.isLoading;
    },
    getSidePanelOpen(state) {
      return state.sidePanelOpen;
    },
    getSideTab(state) {
      return state.sideTab;
    },
    isMobile() {
      const md = new MobileDetect(window.navigator.userAgent);
      return typeof (md.mobile() || md.phone()) === 'string';
    },
    getQueryObj(state) {
      return state.queryObj;
    },
    isEmbedded(state) {
      //console.log(window !== window.top)
      return window !== window.top
    },
    getVapLayerOn(state){
      return state.VapLayerOn;
    }
  },
  modules: {
    MapStore,
    LocationSearchStore
  }
});

export default Store;